export default "__VITE_ASSET__8e6e8ac1__"